import { reduce, isEmpty, includes } from 'lodash/fp';
import {
  VISIT_GROUP,
  CLIENT_GROUP,
  CF_VISIT_GROUP,
  VISIT_TRACK_GROUP,
  VisitTrackColumns
} from '../../constants';

const GROUP_TYPES = {
  [VISIT_GROUP]: 'Visit',
  [CLIENT_GROUP]: 'Guest',
  [VISIT_TRACK_GROUP]: 'Visit Tracking Method'
};

const isTrackResultColumn = name =>
  name && name.substr(0, 11) === 'trackResult';

const isVisitAgeColumn = (group, name) =>
  group === VISIT_GROUP && name && name.substr(0, 3) === 'age';

const isVisitHousholdTotal = (group, name) =>
  group === VISIT_GROUP && name === 'household_total';

const isVisitLocationColumn = (group, name) =>
  group === VISIT_GROUP && name === 'location_id';

const isVisitOutreachColumn = (group, name) =>
  group === VISIT_GROUP && name === 'outreach_id';

const includedTextColumns = name =>
  includes(name, ['city', 'state', 'county', 'zipcode']);

const isVisitCustomColumn = (group, column) =>
  group === VISIT_GROUP && /^cf_/.test(column);

const isCustomColumn = column => /^cf_/.test(column);

const isCustomCheckboxColumn = (fieldType, column) =>
  isCustomColumn(column) && fieldType === 'checkbox';

const isCustomNumberColumn = (fieldType, column) =>
  isCustomColumn(column) && fieldType === 'number';

export const visitTrackingMethodColumnToOption = ({ name, label }) => ({
  type: VISIT_GROUP,
  value: `${VISIT_TRACK_GROUP}.${name}`,
  label
});

export const createGroupOption = (group, name, label) => ({
  type: GROUP_TYPES[group],
  value: isVisitCustomColumn(group, name)
    ? `${CF_VISIT_GROUP}.${name}`
    : `${group}.${name}`,
  label
});

export const groupByOptionsFor = (group, columns, isForGroupBy = false) =>
  reduce(
    (all, { label, name, fieldType, options }) =>
      (!isEmpty(options) && !isCustomCheckboxColumn(fieldType, name)) ||
      isVisitHousholdTotal(group, name) ||
      isTrackResultColumn(name) ||
      (!isForGroupBy && isCustomNumberColumn(fieldType, name)) ||
      (!isForGroupBy && isVisitAgeColumn(group, name)) ||
      (isForGroupBy && isVisitLocationColumn(group, name)) ||
      (isForGroupBy && isVisitOutreachColumn(group, name)) ||
      (isForGroupBy && includedTextColumns(name))
        ? [...all, createGroupOption(group, name, label)]
        : all,
    [],
    columns
  );

export const composeGroupByOptions = (clientColumns, visitColumns) => [
  ...groupByOptionsFor(CLIENT_GROUP, clientColumns, true),
  ...groupByOptionsFor(VISIT_GROUP, visitColumns, true)
];

export const composeSumOrCountByOptions = (clientColumns, visitColumns) => [
  ...groupByOptionsFor(CLIENT_GROUP, clientColumns),
  ...groupByOptionsFor(VISIT_GROUP, visitColumns),
  ...groupByOptionsFor(VISIT_TRACK_GROUP, VisitTrackColumns)
];
